<template>
  <div>
    <Head title="SKU Types" />
    <h1 class="mb-8 text-3xl font-bold">SKU Types</h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset" />
      <Link class="btn-orange" href="/sku-types/create">
        <span>Create</span>
        <span class="hidden md:inline">&nbsp;Sku Type</span>
      </Link>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-3 pt-3 px-3">Description</th>
          <th class="pb-3 pt-3 px-3 flex items-center justify-center">Code</th>
          <th class="pb-3 pt-3 px-3 text-center">Categories</th>
          <th class="pb-3 pt-3 px-3">
            <icon name="settings-white" class="block w-6 h-6" />
          </th>
        </tr>
        <tr v-for="type in types.data" :key="type.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
          <td class="border-t">
            <Link class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/sku-type/${type.id}/categories`">
              {{ type.name }}
            </Link>
          </td>
          <td class="border-t">
            <Link class="flex items-center justify-center px-3 py-3" :href="`/sku-type/${type.id}/categories`" tabindex="-1">
              {{ type.code }}
            </Link>
          </td>
          <td class="w-px border-t">
            <Link class="flex items-center justify-center w-full" :href="`/sku-type/${type.id}/categories`" tabindex="-1">
              <icon name="save-in" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
          <td class="w-px border-t">
            <Link class="flex items-center px-3" :href="`/sku-types/${type.id}/edit`" tabindex="-1">
              <icon name="edit-1" class="block w-6 h-6 fill-gray-400" />
            </Link>
          </td>
        </tr>
        <tr v-if="types.data.length === 0">
          <td class="px-3 py-3 border-t" colspan="4">No data found</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="types.links" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
import Pagination from '@/Shared/Pagination'

export default {
  components: {
    Head,
    Icon,
    Link,
    SearchFilter,
    Pagination,
  },
  layout: Layout,
  props: {
    filters: Object,
    types: Array,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
      },
    }
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/sku-types', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
  },
}
</script>
